export const POWER_VERSION_DATA_TEST_ID = 'power-version';
export const TRANSMISSION_VERSION_DATA_TEST_ID = 'transmission-version';
export const LOWERED_VERSION_DATA_TEST_ID = 'lowered-version';
export const POWER_VERSION_FILTER_KEY = 'power';
export const TRANSMISSION_VERSION_FILTER_KEY = 'transmission';
export const LOWERED_VERSION_FILTER_KEY = 'loweredVersion';
